import { ofType } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";
import * as S from "sanctuary";

import { CREATE_ALERT, removeAlert, alertCreated } from "./Alerts.state";

const removeAlertObservable = ({ ttl, id }) =>
  Rx.timer(ttl.value).pipe(RxOp.mapTo(removeAlert({ id })));

const alertTimeoutEpic = (action$) =>
  action$.pipe(
    ofType(CREATE_ALERT),
    RxOp.mergeMap(({ payload: { alert } }) =>
      Rx.merge(
        Rx.of(alertCreated(alert)),
        S.isJust(alert.ttl) ? removeAlertObservable(alert) : Rx.empty()
      )
    )
  );

export default alertTimeoutEpic;
